import React from "react";
import { useDispatch, batch } from "react-redux";
import PropTypes from "prop-types";
import get from "lodash/get";
import { SvgHandler } from "../svg-handler/svg-handler";
import headset from "../../../assets/icons/headset.svg";

import "./amazon-polly.m.css";

export const AmazonPolly = ({ story = {}, customClass = "" }) => {
  const dispatch = useDispatch();
  const storyDataKeys = ["slug", "summary", "headline", "tags", "story-audio"];
  const storyData = storyDataKeys.reduce((acc, key) => ({ ...acc, [key]: story[key] }), {});
  const audioS3Key = get(story, ["story-audio", "s3-key"], "");

  const onClickHandler = () => {
    batch(() => {
      dispatch({ type: "HIDE_METERING_INDICATOR" });
      dispatch({ type: "UPDATE_AMAZON_POLLY_DATA", payload: { storyData } });
      dispatch({ type: "OPEN_AMAZON_POLLY" });
    });
  };

  if (!audioS3Key) return null;

  return (
    <div styleName="amazon-polly-wrapper">
      <div
        data-testid="amazon-polly-text-wrapper"
        styleName="amazon-polly-text-wrapper"
        className={customClass}
        onClick={onClickHandler}
      >
        <div styleName="amazon-polly-headset-wrapper">
          <SvgHandler width="24px" height="24px" xlinkHref={headset} clazzName="amazon-polly-headset" />
        </div>
        <span styleName="amazon-polly-text">Listen to story</span>
      </div>
    </div>
  );
};

AmazonPolly.propTypes = {
  story: PropTypes.object,
  customClass: PropTypes.string
};
